// extracted by mini-css-extract-plugin
export var acitonButtons = "_md-0";
export var additionalIcon = "_md-f";
export var block = "_md-1";
export var blockContent = "_md-7";
export var blockDescription = "_md-8";
export var blockIcon = "_md-9";
export var blockTitle = "_md-6";
export var border = "_md-a";
export var center = "_md-l";
export var edge = "_md-b";
export var edgeLabel = "_md-c";
export var edgePath = "_md-d";
export var error = "_md-e";
export var flowchart = "_md-g";
export var flowchartContent = "_md-h";
export var highlighted = "_md-3";
export var hover = "_md-4";
export var icon = "_md-i";
export var left = "_md-m";
export var navButton = "_md-j";
export var navButtons = "_md-k";
export var right = "_md-n";
export var selected = "_md-2";
export var small = "_md-5";